/**
 * url
 */
export const VIP_URL = 'https://telgroup.slotfree.xyz/c2c/regras_VIP_mx.html';

/**
 * 缓存的key
 */
export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN_KEY';

export const ACCESS_USERID_KEY = 'ACCESS_USERID_KEY';

export const ACCESS_USER_NAME = 'ACCESS_USER_NAME';

export const ACCESS_PIXEL_KEY = 'ACCESS_PIXEL_KEY';

export const YK_BIND_PHONE_KEY = 'YK_BIND_PHONE_KEY';

export const ACCESS_PWA_KEY = 'ACCESS_PWA_KEY';

export const FREE_WITHDRAW_RECEIVE = 'FREE_WITHDRAW_RECEIVE';

export const WITHDRAW_FORM_VALUES = 'WITHDRAW_FORM_VALUES';

export const USER_ACTION_QUIT_KEY = 'USER_ACTION_QUIT_KEY';

/** free bonus 的上次提款code */
export const LAST_WITHDRAW_FREE_CODE = 'LAST_WITHDRAW_FREE_CODE';

/** 救济金的阈值，身金比这个小就会出现救济金的活动和banner */
export const DOLE_NUM = 1;
/** 救济金每天领取上线次数 */
export const DOLE_RECEIVE_NUM = 3;

export interface ITabItem {
  id: number;
  name: string;
  enable?: boolean;
  [x: string]: any;
}

/** tabs */
export const tabs: ITabItem[] = [
  { id: 11, name: 'heart', label: null, enable: true },
  { id: 12, name: 'history', label: null, enable: true },
  { id: 1, name: 'HOT', label: 'POPULAR', enable: true },
  { id: 2, name: 'SLOTS', label: 'SLOTS', enable: true },
  { id: 3, name: 'PP', label: 'PP GAMES', enable: true },
  { id: 4, name: 'PG', label: 'PG SOFT', enable: true }
];
/** tabs */
export const christmas_tabs: ITabItem[] = [
  { id: 1, name: 'HOT', label: 'POPULAR', enable: true },
  { id: 6, name: 'christmas', enable: true, iconType: 'two' },
  { id: 2, name: 'SLOTS', label: 'SLOTS', enable: true },
  { id: 3, name: 'PP', label: 'PP GAMES', enable: true },
  { id: 4, name: 'PG', label: 'PG SOFT', enable: true }
];
/** tabs */
export const fish_tabs: ITabItem[] = [
  { id: 7, name: 'fish', label: 'FISH', enable: true },
  { id: 1, name: 'HOT', label: 'POPULAR', enable: true },
  { id: 2, name: 'SLOTS', label: 'SLOTS', enable: true },
  { id: 3, name: 'PP', label: 'PP GAMES', enable: true },
  { id: 4, name: 'PG', label: 'PG SOFT', enable: true }
];
/** 限时首充每日首次进入的时间，不能作为公共的 */
export const FIRST_RECHARGE_DAILY_FIRST_ENTER = 'FIRST_RECHARGE_DAILY_FIRST_ENTER';

/**
 * 白名单，这里的游戏可以上推荐列表
 * @deprecated
 */
export const recentlyGameWhiteList = [
  'game201',
  'game202',
  'game203',
  'game204',
  'game205',
  'game206',
  'game207',
  'game208',
  'game209',
  'game210',
  'game211',
  'game212',
  'game213',
  'game214',
  'game215',
  'game216',
  'game217',
  'game218',
  'game219',
  'game220',
  'game221',
  'game222',
  'game223',
  'game224',
  'game225',
  'game226',
  'game227',
  'game228',
  'game229',
  'game500'
];
/** 侧边活动的key，存在侧边活动栏的一些本地数据 */
export const ASIDE_ACTIVITY_DATA = 'ASIDE_ACTIVITY_DATA';

/** bonus 页面的信息 */
export const BONUS_DATA = 'BONUS_DATA';

/** 底部导航的信息 */
export const NAVBAR_DATA = 'NAVBAR_DATA';

export const iosForceCollectChannels: string[] = []; // 'H5MX66', 'H5MX67'
